// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"P3-z"};